import Rest from '../Services/Rest'

/**
 * @typedef {PackageService}
 */
export default class PackageService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/package'

   /**
   * @param {Object} record
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  salvar (record) {    
    return this.post('/save', record)
  }

  salvarFormData(record){

    var form_data = new FormData();
    for ( var key in record ) {
      form_data.append(key, record[key]);
    }

    return this.postFormData('/save', form_data)
  }

  
   /**
   * @param {Object} record
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  getOne (id){

    return this.get(`/${id}`)    
  }

  searchProducts(param = ''){
    if(param == ''){
      return [];
    }

    return this.get(`/search?q=${param}`);
  }

  /**
   * @param {Object} parameters
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  search (parameters = {}) {
    var queryString = ''
   
    if( Object.keys(parameters).length ){
      var _p = [];
      
      Object.keys(parameters).map(function(key,index){
        _p.push( key+"="+parameters[key] );
      });
      queryString = "?"+ _p.join("&");
    }
    return this.get(`/all${queryString}`).then(response => ({
      items: response.items 
    }))
  }

}